import { render, staticRenderFns } from "./EventLarge.vue?vue&type=template&id=a3596cea&"
import script from "./EventLarge.vue?vue&type=script&lang=js&"
export * from "./EventLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports